import {ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SenderService} from '../../../services/sender.service';
import {InterfaceService} from '../../../services/interface.service';
import {AllService} from '../../../services/all.service';
import {NzUploadChangeParam} from 'ng-zorro-antd/upload';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {Validators} from '@angular/forms';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {filter} from 'rxjs/operators';
import {Subject, takeUntil} from 'rxjs';
import {ShepherdService} from 'angular-shepherd';
import {DcService} from '../../../services/dc.service';
import {ModalService} from "../../../services/modal.service";

@Component({
  selector: 'app-add-form-sender',
  templateUrl: './add-form-sender.component.html',
  styleUrls: ['./add-form-sender.component.scss']
})
export class AddFormSenderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  disable = false;


  helpSingleMode = 'Получатели получат сообщения по одному разу, после чего рассылка завершится';
  helpLoopMode = 'Рассылка будет осуществляться циклично по всем контактам, завершится после прохода указанного Вами кол-ва полных циклов';
  arPiarContacts = [
    'https://t.me/prezidentpiarchat',
    'https://t.me/FreePR_Fox',
    'https://t.me/PrTalk2',
    'https://t.me/besplatnyipiar',
    'https://t.me/vpuska_ru',
    'https://t.me/SPAMPIAR',
    'https://t.me/ivanstroybonus',
    // 'https://t.me/AdToChat',
    'https://t.me/prfree',
    'https://t.me/vzaumnipiarchat',
    'https://t.me/bestprchat',
    'https://t.me/kingtelegrams',
    'https://t.me/frradv',
    'https://t.me/prprprchat',
    'https://t.me/vzaimnaa_podpiskas',
    // 'https://t.me/PRTalk',
    'https://t.me/piarGo',
    'https://t.me/PRTalk_one',
    'https://t.me/PRsites',
    'https://t.me/SpecPiar',
    'https://t.me/spagetti08',
    'https://t.me/hosting_pr',
    'https://t.me/megi_VP',
    'https://t.me/vp_telegram',
    'https://t.me/vzaymnipiar',
    'https://t.me/piarchat_one',
    'https://t.me/piar_one',
    // 'https://t.me/piar_one[adsbygoogle]',
    'https://t.me/PRmyPRmy',
    'https://t.me/bezdna42',
    // 'https://t.me/piarzero',
    // 'https://t.me/hosting_p',
    'https://t.me/free_pr',
    'https://t.me/TGPR_RealType',
    'https://t.me/piar_kanal',
    'https://t.me/FreeVPP',
    'https://t.me/PRnorules',
    // 'https://t.me/piars',
    // 'https://t.me/podpison',
    'https://t.me/vzaimny_podpison',
    'https://t.me/Piar_Vp_Pop_Group',
    'https://t.me/ipiar',
    'https://t.me/piar_one',
    'https://t.me/piar_podpiska',
    'https://t.me/VPTelegramVP',
    'https://t.me/piarchik_vz',
    'https://t.me/ChatNoRulese',
    'https://t.me/SerejaHypeChat',
    'https://t.me/ReklamaVPChat',
    'https://t.me/reklamavppiar',
    'https://t.me/piarrchaat',
    'https://t.me/piar_chat64',
    // 'https://t.me/zayavi_o_sebe',
    'https://t.me/VzaimpodpiskaVtelege',
    // 'https://t.me/vzaimnaya_podpiskal',
    // 'https://t.me/tmesale',
    'https://t.me/Piartv',
    'https://t.me/piardublechat',
    'https://t.me/pr_vse',
    'https://t.me/piarchat',
    // 'https://t.me/autovp',
    'https://t.me/MaestroPRchat',
    // 'https://t.me/yoject',
    'https://t.me/chaat_vz',
    // 'https://t.me/vzaimnopodpiska_chat',
    'https://t.me/pr_for_alll',
    'https://t.me/PodpiskaVzaimnoO',
    // 'https://t.me/chat_5',
    // 'https://t.me/reklamavpspam',
    'https://t.me/Fly_Up',
    'https://t.me/piarvzaimno',
    'https://t.me/PR_FOR_ALL',
    'https://t.me/piartlg',
    'https://t.me/TG_PR',
    // 'https://t.me/channelPR',
    'https://t.me/VzaimTelegram',
    'https://t.me/tgplug',
    'https://t.me/praislistpodpiska',
    'https://t.me/vzaimnyepodpisk',
    'https://t.me/yourvp',
    // 'https://t.me/vzaimnaya_podpiskat',
    'https://t.me/piarzgroupp',
    'https://t.me/vzaimnie_podpiskii',
    'https://t.me/vzaimnye_podpiski',
    'https://t.me/esk1tpiarchat/1',
    'https://t.me/netvoringanas'
  ];

  @ViewChild('messageText') messageText: ElementRef;

  constructor(
    private dcService: DcService,
    private shepherdService: ShepherdService,
    public telegramService: TelegramService,
    public notifierWrapService: NotifierWrapService,
    public allService: AllService,
    public senderService: SenderService,
    public modalService: ModalService,
    public interfaceService: InterfaceService,
    private cd: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.setLoop();
    // TODO
    this.interfaceService.$onEdtMessage.subscribe(() => {
      this.setLoop();
      // console.log('!!!!!!!!', this.senderService.senderForm)
    });
    this.dcService.detectChanges$.pipe(filter(v => v === 'add-form-sender'), takeUntil(this.destroy$)).subscribe((component) => {
      this.cd.detectChanges();
    });
    /*this.interfaceService.openChat$.subscribe(() => {
      this.senderService.resetForm()
    })*/
  }

  setLoop($event = false): void {
    this.senderService.isLoopEnable = this.senderService.senderForm.get('loop_need_count').value > 0;
    this.cd.detectChanges();
  }

  setLoopChange($event = false): void {
    if (!$event) {
      this.senderService.senderForm.get('loop_interval').setValue(0);
      this.senderService.senderForm.get('loop_need_count').setValue(0);
    }
    this.cd.detectChanges();
  }

  onIndexChange(index: number): void {
    this.senderService.tabIndex = index;
  }

  selectType(sender: number): void {
    this.senderService.setSenderTypes$.next(sender);

    /*if (sender === 1) {
      this.notifierWrapService.notify('warning', 'Извините, временно отключено, доработка.');
      return;
    }*/

    if (sender === 3) {
      this.senderService.senderForm.get('contacts').clearValidators();
      this.senderService.senderForm.get('contacts').setValidators([]);
      this.senderService.senderForm.get('parsed_chat').setValidators([Validators.minLength(2), Validators.required]);
    } else {
      this.senderService.senderForm.get('parsed_chat').clearValidators();
      this.senderService.senderForm.get('parsed_chat').setValidators([]);
      this.senderService.senderForm.get('contacts').setValidators([Validators.minLength(5), Validators.required]);
      if (sender === 2) {}
    }
    setTimeout(() => {
      this.focusTextArea();
    }, 500);
    this.senderService.tabIndex = 1;
    if (sender === 1) {
      if (!this.senderService.senderForm.get('contacts').value) {
        this.senderService.senderForm.get('contacts').setValue(this.arPiarContacts.join('\n'));
      }
    }
    this.senderService.senderType = sender;
  }

  focusTextArea() {
    try {
      this.messageText.nativeElement.focus();
    } catch (e) {
    }
  }

  handleChange(info: NzUploadChangeParam): void {
    alert('Еще в разработке :(');
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
    } else if (info.file.status === 'error') {
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNextContacts() {
    this.onIndexChange(2);
    if (this.shepherdService.isActive) {
      this.shepherdService.next();
    }
  }
}
